import type { TFunction } from 'i18next';
import { NS } from '../../../U3206';

interface U3206DataAccessPreviewPanelProps {
  allowedQuestions: string[];
  blockedQuestions: string[];
  t: TFunction;
}

function U3206DataAccessPreviewPanel({ allowedQuestions, blockedQuestions, t }: U3206DataAccessPreviewPanelProps) {
  return (
    <aside className="rounded-lg border border-border bg-muted/20 p-4">
      <h3 className="text-sm font-semibold">{t('dataAccessPreviewTitle', { ns: NS })}</h3>

      <div className="mt-4 space-y-4">
        <div>
          <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
            {t('dataAccessPreviewAllowed', { ns: NS })}
          </p>
          {allowedQuestions.length === 0 ? (
            <p className="mt-2 text-sm text-muted-foreground">{t('dataAccessPreviewNone', { ns: NS })}</p>
          ) : (
            <ul className="mt-2 space-y-1 text-sm">
              {allowedQuestions.map((question) => (
                <li key={`allowed-${question}`} className="flex gap-2">
                  <span className="text-emerald-600" aria-hidden>
                    ✓
                  </span>
                  <span>{question}</span>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div>
          <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
            {t('dataAccessPreviewBlocked', { ns: NS })}
          </p>
          {blockedQuestions.length === 0 ? (
            <p className="mt-2 text-sm text-muted-foreground">{t('dataAccessPreviewNone', { ns: NS })}</p>
          ) : (
            <ul className="mt-2 space-y-1 text-sm">
              {blockedQuestions.map((question) => (
                <li key={`blocked-${question}`} className="flex gap-2">
                  <span className="text-destructive" aria-hidden>
                    ✗
                  </span>
                  <span>{question}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </aside>
  );
}

export default U3206DataAccessPreviewPanel;
